export default "__VITE_ASSET__DpsF1$sm__"